import React from 'react'
import './Copyright.scss';

import { images } from '../../constants'
import { BsGithub, BsInstagram, BsLinkedin, AiOutlineMail} from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import { motion } from 'framer-motion'

const Copyright = () => {
  return (
<>

  <div className='copyright-container'>
    <div className='footer-icons'>

    <div className='footer-icon'>

    <a href='https://github.com/PopeUni' target="_blank" rel="noopener noreferrer">
    <motion.div
      className='icon-pos'
      whileInView={{opacity: 1}}
      whileHover={{scale:1.1}}
      transition={{duration: 0.15, type: 'tween'}} 
    >
      
      <BsGithub />
  
    </motion.div>
    </a>
    </div>



    
    <div className='footer-icon'>
    <a href='https://www.instagram.com/jake.metcalfe99/' target="_blank" rel="noopener noreferrer">
    <motion.div
      className='icon-pos'
      whileInView={{opacity: 1}}
      whileHover={{scale:1.1}}
      transition={{duration: 0.15, type: 'tween'}}
    >
    <BsInstagram/>
    </motion.div>
    </a>
    </div>
    


    <div className='footer-icon'>
    <a href='https://www.linkedin.com/in/jacob-metcalfe-55bb5b1a3/' target="_blank" rel="noopener noreferrer">

    <motion.div
      className='icon-pos'
      whileInView={{opacity: 1}}
      whileHover={{scale:1.1}}
      transition={{duration: 0.15, type: 'tween'}}
    >
      
      <BsLinkedin />
      
    </motion.div>
    </a>
    </div>
    
    
  </div>


    <div className="copyright-tag">
     <p className="copy-text">@2022 JACOB METCALFE</p>
      <p className="copy-text">All Rights Reserved</p>
    </div>
  </div>
  </>
  )
}

export default Copyright